var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"u-bare-list"},_vm._l((_vm.links),function(link,index){return _c('li',{key:index},[_c('Link',{attrs:{"model":link}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }